import { useMemo } from 'react'
import { useEventLiveKitLivePublisherIdentities } from '@/components/livekit/EventLiveKitProvider'
import type { StreamStatus } from '@/types/events'

export function useLivePublisherIdentities(): ReadonlySet<string> {
  return useEventLiveKitLivePublisherIdentities()
}

/**
 * Hook to determine whether a stream has an active LiveKit video track.
 *
 * @param participantIdentity - The LiveKit participant identity for the stream
 * @param status - The current stream lifecycle status from the backend
 * @returns Object with hasTrack and isLive, both sourced from LiveKit track presence
 */
export function useStreamLiveStatus(
  participantIdentity?: string | null,
  status?: StreamStatus,
) {
  void status
  const livePublisherIdentities = useLivePublisherIdentities()

  const hasTrack = useMemo(() => {
    if (!participantIdentity) return false
    return livePublisherIdentities.has(participantIdentity)
  }, [livePublisherIdentities, participantIdentity])

  // LiveKit publisher presence is the viewer-facing source of truth for live.
  const isLive = hasTrack

  return { hasTrack, isLive }
}
